import { render, staticRenderFns } from "./PatientRepeatMedical.vue?vue&type=template&id=10991c38"
import script from "./PatientRepeatMedical.vue?vue&type=script&lang=js"
export * from "./PatientRepeatMedical.vue?vue&type=script&lang=js"
import style0 from "./PatientRepeatMedical.vue?vue&type=style&index=0&id=10991c38&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports